import { Component, computed, input } from '@angular/core';

// Bars of the last months on one scale, the current month highlighted
@Component({
  selector: 'app-sparkline',
  standalone: true,
  template: `
    <svg class="spark" viewBox="0 0 120 34" preserveAspectRatio="none" role="img" [attr.aria-label]="label()">
      @for (bar of bars(); track $index) {
        <rect [class.last]="bar.last" [attr.x]="bar.x" [attr.y]="bar.y" [attr.width]="bar.width" [attr.height]="bar.height" rx="1.5"></rect>
      }
    </svg>
  `,
  styles: [`
    :host { display: block; }
    .spark { width: 100%; height: 34px; display: block; }
    rect { fill: color-mix(in srgb, var(--app-accent) 30%, transparent); }
    rect.last { fill: var(--app-accent); }
  `]
})
export class SparklineComponent {
  values = input.required<number[]>();
  label = input('');

  bars = computed(() => {
    const values = this.values().map(v => Math.max(v, 0));
    const max = Math.max(...values, 0);
    const gap = 4;
    const width = (120 - gap * (values.length - 1)) / values.length;
    return values.map((v, i) => {
      // Months without values keep a thin bar so the position of each month stays visible
      const height = max ? Math.max(2, v / max * 32) : 2;
      return { x: i * (width + gap), y: 34 - height, width, height, last: i == values.length - 1 };
    });
  });
}
